// SessionStorage
// 域名配置
export const HsUtilWebDomainCFG = 'HsUtil_WebDomainCFG';
export const HsUtilEntryUrl = 'HsUtil_EntryUrl';

// Cookie
export const HsUtilLang = 'lang';

export const HsUtilFundAcc = 'FUND_ACC';

// Params
export const HsUtilFundAccParams = '_fundAcc';

// 预加载图片缓存
export const HsUtilPreloadImages = 'HsUtil_PreloadImages';

// Google
export const HsUtilGoogleReCaptacha = 'HsUtil_GoogleReCaptacha';
